'use client';

import React, { forwardRef } from 'react';
import { cn } from '@/components/ui/_lib/cn';
import type { UiSkeletonProps } from '@/components/ui/_lib/skeletonProps';
import { useDeferredSkeleton } from '@/components/ui/_lib/useDeferredSkeleton';
import { SKELETON_BY_COMPONENT } from '@/components/ui/_lib/skeletonRegistry';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & { 'aria-label'?: string; 'aria-labelledby'?: string; title?: string } & UiSkeletonProps;

const sk = SKELETON_BY_COMPONENT.Textarea;

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>((props, ref) => {
  const {
    skeleton = false,
    skeletonMaxWaitMs = 2000,
    skeletonLines,
    className,
    children,
    ...domProps
  } = props;

  const showSkeleton = useDeferredSkeleton(skeleton, skeletonMaxWaitMs);

  if (sk.voidLike && showSkeleton) {
    return (
      <span
        ref={ref as React.Ref<HTMLSpanElement>}
        className={cn('skeleton', `skeleton-${sk.shape}`, className)}
        aria-hidden
      />
    );
  }

  return (
    <textarea       ref={ref}
      className={cn('group', 'textarea', className)}
      {...domProps}
    >
      {children}
    
    </textarea>
  );
});

Textarea.displayName = 'Textarea';

export default Textarea;
